export interface DatepickerModel {
  date: Date
  hours: {
    start: string
    duration: string
  }[]
}

export const getHoursAndMinutes = () => {
  const getTime = []
  for (let i = 0; i <= 23; i++) {
    getTime.push(
      { value: `${i}:00`, label: `${i}:00` },
      { value: `${i}:15`, label: `${i}:15` },
      { value: `${i}:30`, label: `${i}:30` },
      { value: `${i}:45`, label: `${i}:45` },
    )
  }
  return getTime
}

export const getDuration = () => {
  const getTime = []
  for (let i = 0; i <= 23; i++) {
    getTime.push({ value: `${i + 1}`, label: `${i + 1}h` })
  }
  return getTime
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/DateStep/DateStep.model.ts